// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"PublishExamResults_modalRoot__32SLS","root":"PublishExamResults_root__1dSIz","loading":"PublishExamResults_loading__24XoK","note":"PublishExamResults_note__URkv_"};